import BreadCrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import Modal from "../../common/Modal";
import Table from "../../common/table";
import ReactTooltip from "react-tooltip";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import Icon from "../../icons/index";
import swal from "sweetalert2";
import { useStore } from "../../../zustand/store";
import qs from "qs";
import CS from "../../../services/commonService";
import SingleStatusToggle from "../../common/singleStatusToggle";
import React, { useState, useEffect } from "react";

import { pageToLoadOnDelete } from "../../../helpers";
import AddUpdatePlans from "./AddUpdatePlans";
import AddPlans from "./AddPlans";
import {
	useGetSubscriptionPlans,
	useUpdateSubscriptionPlan,
	useGetRestaurantPlanById,
} from "../../../queryHooks/useSubscriptions";

const dummy_data = {
	items_per_page: 1,
	records: [
		{
			label: "test1",
			price: 20,
			interval: 10,
			unit: "Day",
			is_active: false,
		},
		{
			label: "test 2",
			price: 20,
			interval: 10,
			unit: "month",
			is_active: false,
		},
	],
};

//	Pre-defined values
const statusOptions = [
	{ value: true, label: "Active" },
	{ value: false, label: "Inactive" },
];

const columnKey = "plans";
//	Component starts
const Plans = () => {
	//	State values
	const [plan, setPlan] = useState({});
	const [open, setOpen] = useState(false);

	const [tableData, setTableData] = useState([]);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [pageNow, setPageNow] = useState(1);
	const setLoading = useStore((state) => state.setLoading);
	const [plansPayload, setPlansPayload] = useState({
		pagination: true,
		items_per_page: itemsPerPage,
		page: pageNow,
		sort: { created_at: "DESC" },
	});

	const {
		data: subscriptionPlansData,
		refetch,
		isLoading,
	} = useGetSubscriptionPlans(qs.stringify(plansPayload));
	const { data: updateData, mutateAsync: updatePlans } =
		useUpdateSubscriptionPlan();
	useEffect(() => {
		if (subscriptionPlansData && subscriptionPlansData?.status === "success") {
			let respData = subscriptionPlansData?.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [subscriptionPlansData]);

	useEffect(() => {
		if (updateData) {
			setLoading(false);
			if (updateData?.status === "success") {
				CS.showSuccessMessage("Status updated successfully");
				refetch();
			} else if (updateData?.status === "fail") {
				CS.showErrorMessage(updateData?.message);
			}
		}
	}, [updateData]);

	const closeModal = () => {
		setPlan({});
		setOpen(false);
	};

	const columns = [
		{
			label: "Name",
			type: "string",
			sort: true,
			path: "label",
			alias: "label",
		},
		{
			label: "Price",
			type: "number",
			path: "price",
			alias: "price",
			content: (item) => <div className="float-left">{`$ ${item.price}`}</div>,
		},
		{
			label: "Billing Interval",
			type: "string",
			path: "billing_period",
			alias: "billing_period",
		},
		{
			label: "Billing unit",
			type: "string",
			path: "billing_period_unit",
			alias: "billing_period_unit",
		},
		{
			label: "Status",
			type: "boolean",
			filterOptions: statusOptions,
			path: "is_active",
			aliasFilter: "is_active",
			content: (item) => (
				<SingleStatusToggle
					_id={`${item?.id}${item?.is_active}`}
					status={item.is_active}
					onToggleChange={() => {
						updatePlans({
							id: item?.id,
							body: {
								is_active: item?.is_active === 0 ? true : false,
							},
						});
						setLoading(true);
					}}
					htmlFor={`${item?.id}${item?.is_active}`}
				/>
			),
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="edit"
						data-tip
						data-for="edit"
						onClick={() => {
							setPlan(item);
							setOpen(true);
						}}
					/>
					<ReactTooltip id="edit" place="top" effect="solid">
						Edit
					</ReactTooltip>
				</>
			),
		},
	];

	const { data: planConfigDetails, mutateAsync: getPlanById } =
		useGetRestaurantPlanById();
	useEffect(() => {
		if (plan?.id) {
			getPlanById(plan.id);
		}
	}, [plan]);

	return (
		<>
			<BreadCrumbs
				title="Subscriptions"
				data={[{ label: "Subscriptions Plans" }]}
			/>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static"></div>
									<div className="col-sm-4">
										<div className="right-buttons d-flex justify-content-end">
											<button
												onClick={() => setOpen(true)}
												id="addNewCoupon"
												type="button"
												className="btn glow-primary btn-primary"
											>
												<i className="bx bx-user-plus d-lg-none" />
												<span className="d-none d-sm-none d-lg-inline-block">
													Create Plan
												</span>
											</button>
										</div>
									</div>
								</div>
							</div>
							<Modal open={open} onCloseModal={closeModal}>
								<AddUpdatePlans
									plan={plan}
									columnKey={columnKey}
									closeModal={closeModal}
									refetch={refetch}
									planConfigDetails={planConfigDetails}
								/>
							</Modal>

							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setPlansPayload({
										...plansPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setPlansPayload({
										...plansPayload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setPlansPayload({
										...plansPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(plansPayload.filter, obj);
										setPageNow(1);
										setPlansPayload({
											...plansPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setPlansPayload({
											...plansPayload,
											filter: {
												...plansPayload.filter,
												[obj.alias]: String(obj.filter),
											},
											page: 1,
										});
									}
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Plans;
